import { useState } from 'react';
import { Button, Form, FormItem, Input } from '@/components/atoms';
import DefaultModal from '@/components/organisms/common/modal/DefaultModal';
import { ModalStaticFunctions } from 'antd/lib/modal/confirm';
import api from '@/api';
import { message } from 'antd';

export type ManageUserChangePasswordModalProps = {
  visible: boolean;
  onClose: () => void;
  modal?: Pick<ModalStaticFunctions, 'info' | 'confirm'>;
};

const ManageUserChangePasswordModal = ({ visible, onClose, modal }: ManageUserChangePasswordModalProps) => {
  const [pass, setPass] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [currentForm] = Form.useForm();
  const [changeForm] = Form.useForm();

  const onCurrentFinish = (values: any) => {
    api
      .post('/user/password/check', 'puser.PbUserPasswordChangeRequest', { oldPassword: values.current })
      .then(() => {
        setPass(true);
        setCurrentPassword(values.current);
      })
      .catch(() => {
        message.error('비밀번호가 일치하지 않습니다.');
      });
  };

  const onChangeFinish = (values: any) => {
    api
      .post('/user/password', 'puser.PbUserPasswordChangeRequest', { oldPassword: currentPassword, newPassword: values.change })
      .then(() => {
        message.success('비밀번호가 변경되었습니다.');
        onClose();
      })
      .catch(() => {
        message.error('비밀번호가 일치하지 않습니다.');
      });
  };

  return (
    <DefaultModal modalVisible={visible} titleText="비밀번호 변경" onCancel={onClose}>
      {!pass && (
        <Form layout="vertical" form={currentForm} onFinish={onCurrentFinish}>
          <FormItem label="비밀번호" name="current" rules={[{ required: true, message: '비밀번호를 입력하세요.' }]}>
            <Input type="password" />
          </FormItem>
          <FormItem>
            <Button type="dark" shape="round" htmlType="submit">
              확인
            </Button>
          </FormItem>
        </Form>
      )}
      {pass && (
        <Form layout="vertical" form={changeForm} onFinish={onChangeFinish}>
          <FormItem label="새 비밀번호" name="change" rules={[{ required: true, message: '새 비밀번호를 입력하세요.' }]}>
            <Input type="password" />
          </FormItem>
          <FormItem label="비밀번호 확인" name="confirm" rules={[{ required: true, message: '비밀번호를 다시 입력하세요.' }]}>
            <Input type="password" />
          </FormItem>
          <FormItem>
            <Button type="dark" shape="round" htmlType="submit">
              확인
            </Button>
          </FormItem>
        </Form>
      )}
    </DefaultModal>
  );
};

export default ManageUserChangePasswordModal;
